export default [
  {
    organizationId: '08d8fb3f-634f-4c1a-8eea-b11fedef3ce4',
    name: 'userOutsideOfRePack'
  },
  {
    organizationId: 'd7f0b5d3-17ae-4bbc-a2b2-4da53cdadb32',
    name: 'RePack'
  }
];
